export default "__VITE_ASSET__CgmKM33d__"